<div class="request-component">
    <core-helpers-box-loading [hidden]="loaded || failed"></core-helpers-box-loading>
    <div class="app-wrapper" *ngIf="loaded && !failed">
      <nav class="tab_navigation">
        &nbsp;
      </nav>
      <section class="main-content">
        <div class="app-main">
          <header>
            <core-title-section-labels [text]="'Now viewing project #' + request.id" [labels]="request.labels"></core-title-section-labels>
          </header>
          <h3>Anotate your file</h3>
            <core-legacy-notes-pagination [file]="file" [notes]="notes"(onClick)="onSave($event)"></core-legacy-notes-pagination>
        </div>
      </section>
    </div>
    <core-layout-error-not-found *ngIf="failed"></core-layout-error-not-found>
</div>
